/**
 * Ajuste les prix au pied carré après que Bold ait mis à jour les prix.
 * - Listes: .price-per-sqft-block (source Bold + .price-per-sqft-computed)
 * - Page produit: #productPrice (thème/Bold) + .price-per-sqft-product-page
 */
(function() {
  'use strict';

  var moneyFormat = window.themeInfo && window.themeInfo.money_format;
  if (!moneyFormat && typeof app !== 'undefined' && app.data && app.data.money_format) {
    moneyFormat = app.data.money_format;
  }
  if (!moneyFormat && document.getElementById('bold-platform-data')) {
    try {
      var platformData = JSON.parse(document.getElementById('bold-platform-data').textContent);
      moneyFormat = platformData.shop && platformData.shop.money_format;
    } catch (e) {}
  }

  function parseFormattedPrice(text) {
    if (!text || typeof text !== 'string') return 0;
    var cleaned = text.trim().replace(/\s/g, '');
    var match = cleaned.match(/(\d+)[.,](\d{2})/);
    if (match) {
      return parseFloat(match[1] + '.' + match[2]) || 0;
    }
    return parseFloat(cleaned.replace(/[^\d.-]/g, '')) || 0;
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function updatePricePerSqft() {
    var blocks = document.querySelectorAll('.price-per-sqft-block');
    blocks.forEach(function(block) {
      var source = block.querySelector('.money[data-product-id]');
      var computed = block.querySelector('.price-per-sqft-computed');
      var rowCoverage = parseFloat(block.getAttribute('data-row-coverage'));
      if (!source || !computed || !rowCoverage || rowCoverage <= 0) return;

      var priceText = source.textContent || source.innerText;
      var priceDollars = parseFormattedPrice(priceText);
      if (priceDollars <= 0) return;

      var priceCents = Math.round(priceDollars * 100);
      var pricePerSqftCents = Math.round(priceCents / rowCoverage);
      var formatted = formatMoney(pricePerSqftCents);

      if (computed.classList.contains('price-per-sqft-info')) {
        computed.textContent = '(' + formatted + ' du pi.ca.)';
      } else {
        computed.textContent = formatted + ' / pi.ca.';
      }
    });

    document.querySelectorAll('.price-per-sqft-product-page').forEach(function(computed) {
      var rowCoverage = parseFloat(computed.getAttribute('data-row-coverage'));
      if (!rowCoverage || rowCoverage <= 0) return;

      var productPrice = document.getElementById('productPrice');
      if (!productPrice) return;

      var priceText = productPrice.textContent || productPrice.innerText;
      var priceDollars = parseFormattedPrice(priceText);
      if (priceDollars <= 0) return;

      var priceCents = Math.round(priceDollars * 100);
      var pricePerSqftCents = Math.round(priceCents / rowCoverage);
      var formatted = formatMoney(pricePerSqftCents);
      computed.textContent = '(' + formatted + ' du pi.ca.)';
    });
  }

  function init() {
    updatePricePerSqft();

    var blocks = document.querySelectorAll('.price-per-sqft-block');
    blocks.forEach(function(block) {
      var source = block.querySelector('.money[data-product-id]');
      if (source) {
        var observer = new MutationObserver(updatePricePerSqft);
        observer.observe(source, { childList: true, characterData: true, subtree: true });
      }
    });

    var productPrice = document.getElementById('productPrice');
    if (productPrice) {
      var observer = new MutationObserver(updatePricePerSqft);
      observer.observe(productPrice, { childList: true, characterData: true, subtree: true });
    }

    setTimeout(updatePricePerSqft, 2500);
    setTimeout(updatePricePerSqft, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof window.BOLD !== 'undefined' && window.BOLD.common && window.BOLD.common.eventEmitter) {
    try {
      window.BOLD.common.eventEmitter.on('BOLD_COMMON_cart_loaded', updatePricePerSqft);
      window.BOLD.common.eventEmitter.on('BOLD_COMMON_variant_changed', function() {
        setTimeout(updatePricePerSqft, 100);
      });
    } catch (e) {}
  }

  document.addEventListener('change', function(e) {
    if (e.target && e.target.matches('.single-option-selector')) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (form) {
        setTimeout(updatePricePerSqft, 150);
      }
    }
  });
})();
